// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForgetPassword {
  color: white;
}
.forgetPasswordContainer1 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column !important;
}
.forgetPasswordText1 {
  font-family: "Poppins", sans-serif;
  font-weight: 600px;
  font-size: 24px;
  line-height: 32px;
}
.forgetPasswordText2Container {
  margin-top: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.forgetPasswordText2 {
  font-family: "Poppins", sans-serif;
  font-weight: 400px;
  font-size: 16px;
  line-height: 24px;
}
.forgetPasswordInputContainer{
    margin-top: 56px;
    position: relative;
}
.backToSignInText {
  margin-top: 38px;
  font-size: 16px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  color: #48d1cc;
  cursor: pointer;
}

/* Error tooltip styles */
.errorTooltip {
    position: absolute;
    top: 100%;
    left: 0;
    font-size: 12px;
    margin-top: 4px;
    white-space: wrap;
    z-index: 10;
    pointer-events: none;
    display: inline-block;
    padding: 6px 10px;
    border-radius: 6px;
    line-height: 1.2;
    background-color: #ef4444; /* red-500 */
    color: #ffffff;
}

@media (max-width: 1640px) {
  .backToSignInText {
    margin-top: 34px;
    font-size: 14px;
}
}
@media (max-width: 1440px) {
  .backToSignInText {
    margin-top: 32px;
    font-size: 13px;
  }
}
@media (max-width: 1280px) {
  .backToSignInText {
    margin-top: 30px;
    font-size: 12px;
  }
}
@media (max-width: 1024px) {
  .backToSignInText {
    margin-top: 26px;
    font-size: 10px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Components/SignInFlow/ForgetPassword/ForgetPassword.css"],"names":[],"mappings":"AAGA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,oBAAoB;IACpB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB,EAAE,YAAY;IACvC,cAAc;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;AACnB;AACA;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n.ForgetPassword {\n  color: white;\n}\n.forgetPasswordContainer1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column !important;\n}\n.forgetPasswordText1 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 600px;\n  font-size: 24px;\n  line-height: 32px;\n}\n.forgetPasswordText2Container {\n  margin-top: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.forgetPasswordText2 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: 400px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.forgetPasswordInputContainer{\n    margin-top: 56px;\n    position: relative;\n}\n.backToSignInText {\n  margin-top: 38px;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: \"Inter\", sans-serif;\n  color: #48d1cc;\n  cursor: pointer;\n}\n\n/* Error tooltip styles */\n.errorTooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    font-size: 12px;\n    margin-top: 4px;\n    white-space: wrap;\n    z-index: 10;\n    pointer-events: none;\n    display: inline-block;\n    padding: 6px 10px;\n    border-radius: 6px;\n    line-height: 1.2;\n    background-color: #ef4444; /* red-500 */\n    color: #ffffff;\n}\n\n@media (max-width: 1640px) {\n  .backToSignInText {\n    margin-top: 34px;\n    font-size: 14px;\n}\n}\n@media (max-width: 1440px) {\n  .backToSignInText {\n    margin-top: 32px;\n    font-size: 13px;\n  }\n}\n@media (max-width: 1280px) {\n  .backToSignInText {\n    margin-top: 30px;\n    font-size: 12px;\n  }\n}\n@media (max-width: 1024px) {\n  .backToSignInText {\n    margin-top: 26px;\n    font-size: 10px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
